import { render, staticRenderFns } from "./ModalRenameProductsList.vue?vue&type=template&id=be4641ca&"
import script from "./ModalRenameProductsList.vue?vue&type=script&lang=js&"
export * from "./ModalRenameProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports